import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { ToastrService } from 'ngx-toastr';
import { MyClientComponent } from '../my-client/my-client.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-appointment-request',
  templateUrl: './appointment-request.component.html',
  styleUrls: ['./appointment-request.component.scss']
})
export class AppointmentRequestComponent implements OnInit {
  email: any;
  reason: any;
  updateToaster: any;
  showSpinner : boolean  = false;
  loading: boolean = false;
  

  constructor(@Inject(MAT_DIALOG_DATA) public editData: any,
  public translate: TranslateService,
  private toastr: ToastrService,
  public apiCall: ApiCall,
  public dialog: MatDialog,
  public dialogRef: MatDialogRef<MyClientComponent>,
  private router : Router,) { }

  ngOnInit(): void {
  }

  sendEmail() {
    this.loading = true;
    this.showSpinner = true;
    var len = this.email.split(/[\s]+/);
    if(len.length > 250){
      this.translate.get('LIMIT_EXCEEDS_EMAIL').subscribe((res:string)=>{
        this.toastr.error(res,'')
        this.loading = false;
        this.showSpinner = false;
        this.dialogRef.close(true);
      });
    }else{
      let data =  { 
         appUser : this.editData.tempData, email:this.email
  }
  this.apiCall.sendRequestForAppointment(data).subscribe(
    (res: any) => {
      if (res.status == 'SUCCESS') {
       
        let message;
        this.translate.get(['EMAIL_SEND_SUCCESS'])
        .subscribe(translations => {
          message = translations['EMAIL_SEND_SUCCESS'];
        });
        this.toastr.success(message,'');
      } else {
        console.log('Error:', res.error);
        let message;
        this.translate.get(['EMAIL_SEND_FAIL'])
        .subscribe(translations => {
          message = translations['EMAIL_SEND_FAIL'];
        });
        this.toastr.error(message, '')
      }
      this.loading = false;
      this.showSpinner = false;
      this.dialogRef.close(true);
    },
    (error: any) => {
      console.log('Error:', error);
    }
  );
    }
  }

  ngAfterViewInit() {
    if(document.getElementById('text')) {
      document.getElementById('text').blur();
    }
  }
  cancel(): void {
    this.dialogRef.close(false);
  }
  
}  
